// extracted by mini-css-extract-plugin
export default {"button":"ReservationButton_button__iU8BR","humed":"ReservationButton_humed__UoBaT","toggleButton":"ReservationButton_toggleButton__vPiaA","hidden":"ReservationButton_hidden__uMG2M"};